export enum Days {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export enum CalendarViews {
  Weeks,
  MonthSelector,
  YearSelector,
}
